import Login from './Login';
import Routes from '../routes/routes';

const LoginWrapper = () => {
  return <Login mainLayout={true} redirectUrl={Routes.app.dashboard} />;
};

export default LoginWrapper;
